import { Link } from 'react-router-dom';

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/694b00a41c68dbe116920e19_t1.png"
                alt="Security Team"
                className="w-full h-64 object-cover rounded-lg"
              />
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/694b014df61ddc0361fdee96_American%20Guard%20Services_20251218-142%201.png"
                alt="Professional Guards"
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <div className="space-y-4 pt-8">
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/68b8c3d72b8ec39b562c5f69_AGS-Campus-Security.avif"
                alt="Campus Security"
                className="w-full h-48 object-cover rounded-lg"
              />
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/68b9f4bea8fcf0425c5bb544_AGS-sub-banner-Special-Event-Security.avif"
                alt="Event Security"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
          </div>

          <div>
            <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">
              The Nation's Most Trusted Security Provider
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mt-4 mb-6 font-display">
              Your Partner In Public Safety
            </h2>
            <p className="text-dark-600 text-lg mb-6 leading-relaxed">
              American Guard Services, Inc. is an established and accredited nationwide security provider. Founded in 1997, we have grown into a trusted full-service security company with locations across the nation.
            </p>
            <p className="text-dark-600 text-lg mb-8 leading-relaxed">
              As a family-owned business that is proudly woman owned and led, we bring a personal commitment to excellence that sets us apart in the industry.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/about"
                className="px-6 py-3 bg-primary-500 text-dark-900 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap inline-flex items-center cursor-pointer"
              >
                Learn More About Us
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/contact"
                className="px-6 py-3 bg-dark-100 text-dark-900 rounded-lg text-sm font-semibold hover:bg-dark-200 transition-colors whitespace-nowrap inline-flex items-center cursor-pointer"
              >
                Get A Quote
                <i className="ri-file-text-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;